import { APIGET } from '../utils/apiHelper';
import { TMXSTORE_GET_STORE_BY_ID } from './getters.type';

const state = {
  tmxStores: {
    type: 'FeatureCollection',
    features: [
      {
        geometry: {
          type: 'Point',
          coordinates: [19.070615, 47.494666],
        },
        type: 'Feature',
        properties: {
          storeid: 1,
          category: 'TMX',
          name: 'Huawei CSC József krt.',
          description: 'Huawei készülékek javítása - akár egy órán belül!',
          description2: 'pageStores.huaweiDesc',
          img_path: 'tmx_store_huawei_jozsef_korut_small.jpg',
          img_path_big: 'tmx_store_huawei_jozsef_korut_1024.jpg',
          address: '1085 Budapest, József krt. 17.',
          hours: 'Hétfőtől péntekig: 9:00 - 15:00,<br>Szombat, Vasárnap: ZÁRVA',
          address2: 'pageStores.huaweiCscAddress',
          hours2: 'pageStores.huaweiCscOpening',
          phone: null,
          path: 'huawei-csc',
          layout_category: 'huawei',
        },
      },
      {
        geometry: {
          type: 'Point',
          coordinates: [19.023838, 47.489950],
        },
        type: 'Feature',
        properties: {
          storeid: 2,
          category: 'TMX',
          name: 'Huawei Hillside',
          description: 'Huawei készülékek javítása - akár egy órán belül!',
          description2: 'pageStores.huaweiDesc',
          img_path: 'tmx_store_huawei_hillside_small.jpg',
          img_path_big: 'tmx_store_huawei_hillside_1024.jpg',
          address: '1123 Budapest, Hillside Irodaház, Alkotás u. 55-61.',
          hours: 'Hétfőtől péntekig: 9:00 - 15:00,<br>Szombat, Vasárnap: ZÁRVA',
          address2: 'pageStores.huaweiHillsideAddress',
          hours2: 'pageStores.huaweiHillsideOpening',
          phone: null,
          path: 'huawei-hillside',
          layout_category: 'huawei',
        },
      },
      {
        geometry: {
          type: 'Point',
          coordinates: [18.966527, 47.450988],
        },
        type: 'Feature',
        properties: {
          storeid: 3,
          category: 'SamsungMSC',
          name: 'Samsung S-Drive',
          description: 'Samsung mobiltelefon, okos óra, tablet valamint fényképezőgép átvétele, autós kiszolgálás is!',
          description2: 'pageStores.samsungDesc',
          img_path: 'tmx_store_samsung_s_drive_budaors_small.jpg',
          img_path_big: 'tmx_store_samsung_s_drive_budaors_1024.jpg',
          address: '2040 Budaörs, Kinizsi u. 1-3. (Tesco - Kika áruház közötti parkoló)',
          hours: 'Hétfőtől péntekig: 9:30 - 15:00<br>Szombat: ZÁRVA<br>Vasárnap: ZÁRVA',
          address2: 'pageStores.samsungAddress',
          hours2: 'pageStores.samsungOpening',
          phone: null,
          path: 'samsung-s-drive',
          layout_category: 'samsung',
        },
      },
    ],
  },
};

const getters = {
  //
};

const actions = {
  async [TMXSTORE_GET_STORE_BY_ID](context, storeId) {
    const store = await context.state.tmxStores.features.find(tmxstore => tmxstore.properties.path == storeId);
    return store;
  },
};

const mutations = {
  //
};

export default {
  state,
  actions,
  mutations,
  getters,
};
